(function () {
  'use strict';

  const settings = window.freeGiftSettings || {};
  const THRESHOLD = settings.threshold || 9000; // en centimes (90€)
  const GIFT_VARIANT_ID = Number(settings.giftVariantId);
  let isProcessing = false;

  if (!GIFT_VARIANT_ID) {
    console.warn('[free-gift] Aucun giftVariantId configuré.');
    return;
  }

  async function getCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  function cartHasGift(cart) {
    return cart.items.some((item) => item.variant_id === GIFT_VARIANT_ID);
  }

  function getEligibleTotal(cart) {
    return cart.items.reduce((sum, item) => {
      if (item.variant_id === GIFT_VARIANT_ID) return sum;
      return sum + item.final_line_price;
    }, 0);
  }

  // Rafraîchit la bulle du panier + la live region, comme le fait CartItems
  // normalement via getSectionsToRender() lors d'un changement de quantité.
  async function refreshCartChrome() {
    try {
      const res = await fetch(
        `${window.routes.cart_url}?section_id=cart-icon-bubble`
      );
      const html = await res.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const bubble = document.getElementById('cart-icon-bubble');
      const newBubble = parsed.getElementById('cart-icon-bubble');
      if (bubble && newBubble) bubble.innerHTML = newBubble.innerHTML;
    } catch (err) {
      console.error('[free-gift] Erreur refresh bubble:', err);
    }
  }

  async function addGift() {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [
          { id: GIFT_VARIANT_ID, quantity: 1, properties: { _free_gift: 'true' } },
        ],
      }),
    });
    await refreshCartChrome();
    // Déclenche le refresh natif de cart-items / cart-drawer-items
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'free-gift' });
    }
  }

  async function removeGift(cart) {
    const giftItemIndex = cart.items.findIndex(
      (item) => item.variant_id === GIFT_VARIANT_ID
    );
    if (giftItemIndex === -1) return;

    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: giftItemIndex + 1, quantity: 0 }),
    });
    await refreshCartChrome();
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'free-gift' });
    }
  }

  async function evaluateCart() {
    if (isProcessing) return;
    isProcessing = true;

    try {
      const cart = await getCart();
      const eligibleTotal = getEligibleTotal(cart);
      const hasGift = cartHasGift(cart);

      if (eligibleTotal >= THRESHOLD && !hasGift) {
        await addGift();
      } else if (eligibleTotal < THRESHOLD && hasGift) {
        await removeGift(cart);
      }
    } catch (err) {
      console.error('[free-gift] Erreur:', err);
    } finally {
      isProcessing = false;
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    // S'abonne au pub/sub interne du thème plutôt qu'à un CustomEvent
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.source === 'free-gift') return; // évite la boucle infinie
        evaluateCart();
      });
    }
    evaluateCart(); // vérification initiale (ex: arrivée sur /cart)
  });
})();